/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Deep_Otter_GazeInputs */

const en_swift_deep_otter_gaze = /** @type {(inputs: Swift_Deep_Otter_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segments and data`)
};

const de_swift_deep_otter_gaze = /** @type {(inputs: Swift_Deep_Otter_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente und Daten`)
};

/**
* | output |
* | --- |
* | "Segments and data" |
*
* @param {Swift_Deep_Otter_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_deep_otter_gaze = /** @type {((inputs?: Swift_Deep_Otter_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Deep_Otter_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_deep_otter_gaze(inputs)
	return de_swift_deep_otter_gaze(inputs)
});